import { render, staticRenderFns } from "./PaxelBox.vue?vue&type=template&id=79e4523c&scoped=true&"
import script from "./PaxelBox.vue?vue&type=script&lang=js&"
export * from "./PaxelBox.vue?vue&type=script&lang=js&"
import style0 from "./PaxelBox.vue?vue&type=style&index=0&lang=css&"
import style1 from "./PaxelBox.vue?vue&type=style&index=1&id=79e4523c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79e4523c",
  null
  
)

export default component.exports